(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/gameguide/views/game-guide-article.js') >= 0) return;  svs.modules.push('/components/components/gameguide/views/game-guide-article.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_cmps=_svs.components=_svs.components||{};
_cmps.gameguide=_cmps.gameguide||{};
_cmps.gameguide.templates=_cmps.gameguide.templates||{};
svs.components.gameguide.templates.game_guide_article = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<div class=\"panel panel-default margin-0\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"components-content-simple_article-simple_article"),((stack1 = (depth0 != null ? lookupProperty(depth0,"article") : depth0)) != null ? lookupProperty(stack1,"attributes") : stack1),{"name":"components-content-simple_article-simple_article","data":data,"indent":"  ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "</div>\n";
},"usePartial":true,"useData":true});
Handlebars.partials['components-components-gameguide-game_guide_article'] = svs.components.gameguide.templates.game_guide_article;
})(svs, Handlebars);


 })(window);